import { isArray, isNil } from 'lodash';
import * as orderService from 'services/orderService';
import useSWR, { mutate } from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWROrderData = Awaited<ReturnType<typeof orderService.getOrderDetailAsync>>;

const useOrder = (orderId: number, load = true): SWRResponse<SWROrderData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_ENDPOINT, orderId] : null,
    async ([_, orderId]) => await orderService.getOrderDetailAsync(orderId)
  );

export const mutateOrder = async (): Promise<unknown> =>
  await mutate((key) => isArray(key) && key[0] === SWR_ORDER_ENDPOINT, undefined);

export const SWR_ORDER_ENDPOINT = 'order';
export default useOrder;
